import React from 'react';

export default React.forwardRef(function ContentTooltip({ children, visible, backgroundClass = 'tw-bg-charcoal-50', role = 'tooltip', ...props }, ref) {
    return (
        visible && (
            <div
                ref={ref}
                {...props}
                className={
                    'tw-flex tw-flex-col tw-gap-y-2 tw-p-3 tw-rounded-lg tw-border-0 tw-opacity-90 tw-w-max tw-z-[999] tw-shadow-primary ' + backgroundClass
                }
                role={role}
            >
                {typeof children === 'string' ? (
                    <div className="tw-p-0 tw-bg-transparent" dangerouslySetInnerHTML={{ __html: children }}></div>
                ) : (
                    <div className="tw-p-0 tw-bg-transparent">{children}</div>
                )}
            </div>
        )
    );
});
